// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__gB7Oq","mapWrapper":"styles_mapWrapper__g5V9d","map":"styles_map__vV5+O"};